import { useEffect, useRef, useState } from "react";
/**
 * Only updates the state, if the component is mounted
 *
 * This is useful to avoid this error: `Can't perform a React state update on an
 * unmounted component` _But don't forget to unbind any unused listeners
 * anyway!_
 */
export const useSafeState = (initial) => {
    const isMounted = useRef(true);
    useEffect(() => () => {
        isMounted.current = false;
    }, []);
    const [state, setState] = useState(initial);
    const setStateIfMounted = (result) => {
        if (!isMounted.current) {
            return;
        }
        setState(result);
    };
    return [state, setStateIfMounted];
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlU2FmZVN0YXRlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hvb2tzL3VzZVNhZmVTdGF0ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQTRCLFNBQVMsRUFBRSxNQUFNLEVBQUUsUUFBUSxFQUFFLE1BQU0sT0FBTyxDQUFDO0FBRTlFOzs7Ozs7R0FNRztBQUNILE1BQU0sQ0FBQyxNQUFNLFlBQVksR0FBRyxDQUMxQixPQUFVLEVBQ3dCLEVBQUU7SUFDcEMsTUFBTSxTQUFTLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBRS9CLFNBQVMsQ0FDUCxHQUFHLEVBQUUsQ0FBQyxHQUFHLEVBQUU7UUFDVCxTQUFTLENBQUMsT0FBTyxHQUFHLEtBQUssQ0FBQztJQUM1QixDQUFDLEVBQ0QsRUFBRSxDQUNILENBQUM7SUFFRixNQUFNLENBQUMsS0FBSyxFQUFFLFFBQVEsQ0FBQyxHQUFHLFFBQVEsQ0FBSSxPQUFPLENBQUMsQ0FBQztJQUUvQyxNQUFNLGlCQUFpQixHQUFnQyxDQUFDLE1BQU0sRUFBRSxFQUFFO1FBQ2hFLElBQUksQ0FBQyxTQUFTLENBQUMsT0FBTyxFQUFFLENBQUM7WUFDdkIsT0FBTztRQUNULENBQUM7UUFDRCxRQUFRLENBQUMsTUFBTSxDQUFDLENBQUM7SUFDbkIsQ0FBQyxDQUFDO0lBRUYsT0FBTyxDQUFDLEtBQUssRUFBRSxpQkFBaUIsQ0FBQyxDQUFDO0FBQ3BDLENBQUMsQ0FBQyJ9